import initialState from 'redux/modules/payment/state/initial-state';

const reducer = (state = initialState, { result = [] }) => ({
  ...state,
  paymentCards: [...result],
  paymentCardsLoaded: true,
});

export default reducer;
